import React from "react";
import { MalimaxDashboard } from "./malimax-dashboard";

export const AdministratorComponent = React.memo(
  ({ options }: { options: any[] }) => <MalimaxDashboard options={options} />
);
